import axios from 'axios'

const baseURL = process.env.VUE_APP_API_BASE_URL;
const service = axios.create({
  baseURL: baseURL, // 从环境变量读取
  timeout: 10000, // 超时时间
  headers: { 'Content-Type': 'application/json' }
})

// 请求拦截器
service.interceptors.request.use(
  (config) => {
  const token = localStorage.getItem('token')
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
      
      // 添加 X-token，可以根据需要从不同地方获取
      const xToken = localStorage.getItem('x-token') || 
                     sessionStorage.getItem('x-token') || 
                     ''
      if (xToken) {
        config.headers['X-TOKEN'] = xToken
      }
      
      return config
  },
  (error) => Promise.reject(error)
)

// 响应拦截器
service.interceptors.response.use(
  (response) => response.data, // 直接返回数据部分
  (error) => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

export default service